import { getReviewMediaId } from "../utils/review-media-id";
import React, { lazy, Suspense } from "react";

import { PostMediaEditingProvider, usePostMediaEditingModel } from "../model";

import { PostMediaFile } from "shared/types/post";

const CreativePhotoEditorModal = lazy(() =>
  import("ui/photo-editor").then((m) => ({
    default: m.CreativePhotoEditorModal,
  }))
);

interface Props {
  children(params: { onEdit(file: PostMediaFile): void }): React.ReactNode;
  onChange(file: PostMediaFile): void;
}

function PostMediaEditingContent(props: Props) {
  const { state, fileSrc, onEdit, onClose, onSave } =
    usePostMediaEditingModel();
  const { isModalOpened, progress, selectedFile } = state;

  return (
    <>
      {props.children({ onEdit })}
      {isModalOpened && (
        <Suspense fallback={null}>
          <CreativePhotoEditorModal
            image={fileSrc}
            reviewMediaId={getReviewMediaId(selectedFile)}
            assetId={selectedFile?.asset_id ?? selectedFile?._id ?? ""}
            assetUrl={selectedFile?.url ?? ""}
            isReplacingOriginal={false}
            show={isModalOpened}
            onClose={onClose}
            onSave={onSave}
            progress={progress}
            message="This image is being used in an upcoming post. You are creating a new version, make a copy in Library if you would like to keep the original or modify the media through edit post."
            saveButtonText="Save a version"
          />
        </Suspense>
      )}
    </>
  );
}

export function PostMediaEditing(props: Props) {
  return (
    <PostMediaEditingProvider onChange={props.onChange}>
      <PostMediaEditingContent {...props} />
    </PostMediaEditingProvider>
  );
}
